import { DaycareGroupUrlTypes } from '@/types/DaycareGroup'
import {
    AccountBalance,
    AirportShuttle,
    AlternateEmail,
    Apps,
    AttachMoney,
    Attractions,
    Balance,
    BeachAccess,
    Blender,
    Brush,
    Cake,
    Call,
    Celebration,
    Check,
    ChildFriendly,
    Construction,
    CrueltyFree,
    Dining,
    Euro,
    ExitToApp,
    FolderOpen,
    Forest,
    Home,
    Hotel,
    MenuBook,
    MusicNote,
    Newspaper,
    Pool,
    Restaurant,
    Rocket,
    School,
    Security,
    SelfImprovement,
    SignLanguage,
    SportsSoccer,
    SportsTennis,
    TheaterComedy
} from '@mui/icons-material'
import { OccasionalSlotIcon } from '@/types/Slots'
import { JSX } from 'react'

export function getDaycareGroupsIconTextToJSX(icon: DaycareGroupUrlTypes, iconStyle?: string): JSX.Element {
    switch (icon) {
        case DaycareGroupUrlTypes.AccountBalance:
            return <AccountBalance className={iconStyle} />
        case DaycareGroupUrlTypes.AirportShuttle:
            return <AirportShuttle className={iconStyle} />
        case DaycareGroupUrlTypes.Apps:
            return <Apps className={iconStyle} />
        case DaycareGroupUrlTypes.Celebration:
            return <Celebration className={iconStyle} />
        case DaycareGroupUrlTypes.AlternateEmail:
            return <AlternateEmail className={iconStyle} />
        case DaycareGroupUrlTypes.Attractions:
            return <Attractions className={iconStyle} />
        case DaycareGroupUrlTypes.Balance:
            return <Balance className={iconStyle} />
        case DaycareGroupUrlTypes.BeachAccess:
            return <BeachAccess className={iconStyle} />
        case DaycareGroupUrlTypes.Construction:
            return <Construction className={iconStyle} />
        case DaycareGroupUrlTypes.Call:
            return <Call className={iconStyle} />
        case DaycareGroupUrlTypes.Dining:
            return <Dining className={iconStyle} />
        case DaycareGroupUrlTypes.FolderOpen:
            return <FolderOpen className={iconStyle} />
        case DaycareGroupUrlTypes.Home:
            return <Home className={iconStyle} />
        case DaycareGroupUrlTypes.School:
            return <School className={iconStyle} />
        case DaycareGroupUrlTypes.Security:
            return <Security className={iconStyle} />
        case DaycareGroupUrlTypes.SportsSoccer:
            return <SportsSoccer className={iconStyle} />
        case DaycareGroupUrlTypes.Euro:
            return <Euro className={iconStyle} />
        case DaycareGroupUrlTypes.AttachMoney:
            return <AttachMoney className={iconStyle} />
        case DaycareGroupUrlTypes.Newspaper:
            return <Newspaper className={iconStyle} />
        default:
            return <ExitToApp className={iconStyle} />
    }
}

export function getOccasionalSlotsIconTextToJSX(icon: OccasionalSlotIcon, iconStyle?: string): JSX.Element {
    switch (icon) {
        case OccasionalSlotIcon.MusicNote:
            return <MusicNote className={iconStyle} />
        case OccasionalSlotIcon.Blender:
            return <Blender className={iconStyle} />
        case OccasionalSlotIcon.Forest:
            return <Forest className={iconStyle} />
        case OccasionalSlotIcon.Restaurant:
            return <Restaurant className={iconStyle} />
        case OccasionalSlotIcon.Brush:
            return <Brush className={iconStyle} />
        case OccasionalSlotIcon.Hotel:
            return <Hotel className={iconStyle} />
        case OccasionalSlotIcon.MenuBook:
            return <MenuBook className={iconStyle} />
        case OccasionalSlotIcon.SportTennis:
            return <SportsTennis className={iconStyle} />
        case OccasionalSlotIcon.Attractions:
            return <Attractions className={iconStyle} />
        case OccasionalSlotIcon.BeachAccess:
            return <BeachAccess className={iconStyle} />
        case OccasionalSlotIcon.Cake:
            return <Cake className={iconStyle} />
        case OccasionalSlotIcon.Check:
            return <Check className={iconStyle} />
        case OccasionalSlotIcon.ChildFriendly:
            return <ChildFriendly className={iconStyle} />
        case OccasionalSlotIcon.CrueltyFree:
            return <CrueltyFree className={iconStyle} />
        case OccasionalSlotIcon.SelfImprovement:
            return <SelfImprovement className={iconStyle} />
        case OccasionalSlotIcon.Pool:
            return <Pool className={iconStyle} />
        case OccasionalSlotIcon.TheaterComedy:
            return <TheaterComedy className={iconStyle} />
        case OccasionalSlotIcon.SignLanguage:
            return <SignLanguage className={iconStyle} />
        case OccasionalSlotIcon.Rocket:
            return <Rocket className={iconStyle} />
        default:
            return <></>
    }
}
